const STORY_IMG = "https://customer-assets.emergentagent.com/job_the-real-grind/artifacts/4fv7vdwl_LLDN5597.JPG";

export const Story = () => {
  return (
    <section
      id="story"
      data-testid="story-section"
      className="relative bg-[#050505] py-24 md:py-40 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-center">
          {/* Image column */}
          <div className="md:col-span-6 reveal">
            <div className="relative aspect-[4/5] w-full overflow-hidden">
              <img
                src={STORY_IMG}
                alt="Jordan Young portrait"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 text-xs tracking-[0.25em] uppercase text-zinc-300 font-bold">
                Jordan Young · London
              </div>
            </div>
          </div>

          {/* Copy column */}
          <div className="md:col-span-6">
            <div className="reveal flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-zinc-600" />
              <span className="text-xs tracking-[0.3em] uppercase text-zinc-400 font-bold">
                The Story
              </span>
            </div>
            <h2
              data-testid="story-headline"
              className="reveal text-3xl sm:text-4xl lg:text-5xl tracking-tighter font-extrabold text-white leading-[1.05]"
            >
              Built in the real world.
              <br />
              <span className="italic font-light text-zinc-300">
                Not in theory.
              </span>
            </h2>

            <div className="reveal mt-8 space-y-6 text-base md:text-lg leading-relaxed text-zinc-400 font-medium max-w-xl">
              <p>
                Jordan Young is a London entrepreneur who transformed his life
                through business. From early hustles and difficult life
                experiences to building successful companies like{" "}
                <span className="text-white">London Lighting</span> and{" "}
                <span className="text-white">Find My Filmmaker</span>, his
                journey is built on execution, resilience and real-world
                experience — not theory.
              </p>
              <p>
                Unlike most online coaches, Jordan is still actively building
                businesses while mentoring ambitious people who want to turn
                ideas into income and build real discipline, confidence and
                structure.
              </p>
            </div>

            <div className="reveal mt-10 grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-4 max-w-xl">
              {[
                "Entrepreneur from young",
                "Business experience",
                "London Lighting",
                "Find My Filmmaker",
                "Content & branding",
                "Father · Builder",
              ].map((tag) => (
                <div
                  key={tag}
                  className="flex items-center gap-2 text-zinc-300 text-sm"
                >
                  <span className="w-1 h-1 bg-white" />
                  <span className="tracking-tight">{tag}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
